var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M16 4h-2c0-2.21-1.79-4-4-4S6 1.79 6 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM8 8c0 .55-.45 1-1 1s-1-.45-1-1V6h2v2zm2-6c1.1 0 2 .9 2 2H8c0-1.1.9-2 2-2zm4 6c0 .55-.45 1-1 1s-1-.45-1-1V6h2v2z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIvPjxwYXRoIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTE2LDQgTDE0LDQgQzE0LDEuNzkgMTIuMjEsMCAxMCwwIEM3Ljc5LDAgNiwxLjc5IDYsNCBMNCw0IEMyLjksNCAyLDQuOSAyLDYgTDIsMTggQzIsMTkuMSAyLjksMjAgNCwyMCBMMTYsMjAgQzE3LjEsMjAgMTgsMTkuMSAxOCwxOCBMMTgsNiBDMTgsNC45IDE3LjEsNCAxNiw0IFogTTgsOCBDOCw4LjU1IDcuNTUsOSA3LDkgQzYuNDUsOSA2LDguNTUgNiw4IEw2LDYgTDgsNiBMOCw4IFogTTEwLDIgQzExLjEsMiAxMiwyLjkgMTIsNCBMOCw0IEM4LDIuOSA4LjksMiAxMCwyIFogTTE0LDggQzE0LDguNTUgMTMuNTUsOSAxMyw5IEMxMi40NSw5IDEyLDguNTUgMTIsOCBMMTIsNiBMMTQsNiBMMTQsOCBaIi8+PC9nPjwvc3ZnPg==";
export { SvgOrder as ReactComponent };